import {useMemo} from 'react';
import {useResize} from '~/common/hooks/useResize';

const calculateDimensions = (canvasWrapper) => {
  const cs = getComputedStyle(canvasWrapper);
  const paddingX = parseFloat(cs.paddingLeft) + parseFloat(cs.paddingRight);
  const paddingY = parseFloat(cs.paddingTop) + parseFloat(cs.paddingBottom);
  const borderX = parseFloat(cs.borderLeftWidth) + parseFloat(cs.borderRightWidth);
  const borderY = parseFloat(cs.borderTopWidth) + parseFloat(cs.borderBottomWidth);

  const width = canvasWrapper.offsetWidth - paddingX - borderX;
  const height = canvasWrapper.offsetHeight - paddingY - borderY;
  const rationHeight = width * 1.36;

  return rationHeight > height
    ? {height: `${height}px`, width: `${height * 0.735}px`}
    : {width: `${width}px`, height: `${rationHeight}px`};
};

export const useCardDimensions = (parentNode, cardWrapperRef, isMobile, isFree) => {
  const resize = useResize();

  return useMemo(() => {
    if (isMobile && isFree) {
      return {
        height: 'calc(512px - 2rem)',
        width: 'auto',
      };
    }

    const canvasSizer = parentNode ? document.getElementById(parentNode) : null;
    const canvasWrapper = canvasSizer || cardWrapperRef?.current;

    if (!canvasWrapper || !parentNode) {
      return {};
    }

    return calculateDimensions(canvasWrapper);
  }, [parentNode, cardWrapperRef?.current, resize, isMobile, isFree]);
};
